export class Gender {
  static MALE = 1
  static FEMALE = 2
  static OTHER = 3

  constructor(value) {
    this.value = value
  }

  label() {
    return {
      [Gender.MALE]: "Feminine pronouns (e.g. She, Her, Hers)",
      [Gender.FEMALE]: "Masculine pronouns (e.g. He, Him, His)",
      [Gender.OTHER]: "Neutral gender pronouns (e.g. They, Them, Their)",
    }[this.value]
  }
}
